import { Contract, Wallet, ethers } from "ethers";
import { deleteWallet, equipOtherTraits, equipUnequipPower, getNftMetadataByName, previewBeforeMergeNft } from "helpers/backend_helper";
import { getNetworkUrl, nftBgColors } from "helpers/constants";
import useWallet from "hooks/wallet";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { getCollection } from "store/actions";
import Web3Intraction from "util/web3Intraction";

export default function NftBgColorModal({
    nftData,
    userDetail,
  ...props
}) {
const [btnLoader,setBtnLoader] = useState(false);
const [selectedBgColor,setSelectedBgColor] = useState("");
const [previewImageSrc,setPreviewImageSrc] = useState(null)
const [previewLoading,setPreviwLoading]= useState(false);
const { settings } = useSelector((state) => state.Setting);
const dispatch = useDispatch();
const wallet = useWallet();

console.log("nftDAta",nftData)

useEffect(async()=>{
  try {
    if (wallet.account) return;
    console.log("cliecked");
    await wallet.initializeOnBoard();
    
    if (!wallet.account && settings?.blockchainNetworkMode && JSON.stringify(settings) !== "{}") {
      const networkUrl = getNetworkUrl("base", settings);
    console.log("networkUrl onConnectMetamask",networkUrl);
      wallet.connect(
        "metamask",
        networkUrl.chainId || 1
      );
      
    }
  } catch (err) {}
},[wallet.account]);

const getSetPreviewImage = async(color)=>{
    try{
        setPreviewImageSrc(null);
        setPreviwLoading(true);
            let payload= {
              type : "background",
              token_id :parseInt(nftData?.token_id),
              equipment_trait : color,
          };
          
            const respPreview = await previewBeforeMergeNft(payload);
            setPreviewImageSrc(respPreview?.data);
            setPreviwLoading(false);
    }catch(err){
      setPreviwLoading(false);
      console.log("error",err)
    }
}

useEffect(()=>{
    try{
        if(nftData){
            const trait = nftData.attributes.find((attribute) =>attribute.trait_type === "Background");
         setSelectedBgColor(trait.value);
         getSetPreviewImage(trait.value);
        }
    }catch(err){
    console.log("error",err)
    }
},[nftData]);

   
const onChangeBgColor = (value) =>{
   setSelectedBgColor(value);
   getSetPreviewImage(value);
}

    const onSubmit = async (e) =>{
        e.preventDefault();


        if(!previewImageSrc){
          return toast.error("Preview image missing, Something went wrong!")
        }

        try{
            setBtnLoader(true);
            let payload= {
                type : "background",
                token_id :parseInt(nftData?.token_id),
                equipment_trait : selectedBgColor,
                walletAddress: userDetail.walletAddress,
                previewImageLink: previewImageSrc
            };
              const resSP = await equipOtherTraits(payload);  
              setBtnLoader(false);
              if(resSP?.status === "success"){
                props.onhide();
                window.location.reload();
              }
        }
        catch(err){
            setBtnLoader(false);
        }finally{
            setBtnLoader(false);
        }
        //testing code - 
        
       
    };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="wistlist_mod editmod confirm_modal"
    >
      <Modal.Body>
      <h4 className="text-white">Background Color</h4>
        <div className="editmod_inner pt-5">
            
          <a
            href="javascript:void(0)"
            className="close_icon"
            onClick={props.onhide}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="39"
              viewBox="0 0 39 39"
              fill="none"
            >
              <path
                d="M12.75 28.875L19.5 22.125L26.25 28.875L28.875 26.25L22.125 19.5L28.875 12.75L26.25 10.125L19.5 16.875L12.75 10.125L10.125 12.75L16.875 19.5L10.125 26.25L12.75 28.875ZM19.5 38.25C16.9062 38.25 14.4688 37.7575 12.1875 36.7725C9.90625 35.7875 7.92188 34.4519 6.23438 32.7656C4.54688 31.0781 3.21125 29.0938 2.2275 26.8125C1.24375 24.5312 0.75125 22.0938 0.75 19.5C0.75 16.9062 1.2425 14.4688 2.2275 12.1875C3.2125 9.90625 4.54813 7.92188 6.23438 6.23438C7.92188 4.54688 9.90625 3.21125 12.1875 2.2275C14.4688 1.24375 16.9062 0.75125 19.5 0.75C22.0938 0.75 24.5312 1.2425 26.8125 2.2275C29.0938 3.2125 31.0781 4.54813 32.7656 6.23438C34.4531 7.92188 35.7894 9.90625 36.7744 12.1875C37.7594 14.4688 38.2513 16.9062 38.25 19.5C38.25 22.0938 37.7575 24.5312 36.7725 26.8125C35.7875 29.0938 34.4519 31.0781 32.7656 32.7656C31.0781 34.4531 29.0938 35.7894 26.8125 36.7744C24.5312 37.7594 22.0938 38.2513 19.5 38.25Z"
                fill="#fff"
              />
            </svg>
          </a>
        
          <Form onSubmit={onSubmit}>
          <Row className="text-center d-flex justify-content-center">
              <Col md="6" className="my-2">
                   <div className="nft-bgcolors-drop-wrap">
                             <select disabled={btnLoader || !previewImageSrc || previewLoading} value={selectedBgColor} onChange={(e)=>onChangeBgColor(e.target.value)}>
                                   {nftBgColors.map((color)=>
                                   <option value={color}>{color}</option>
                                   )}
                             </select>
                   </div>
                </Col>
                <Col md="6" className="my-2">
                   <div className="equip-nft-cards mx-auto text-center">
                   <div className="img-wrap">
                   {!previewLoading && previewImageSrc && <img key={selectedBgColor} src={`${previewImageSrc}?t=${selectedBgColor}`} width={150} height={150}/>}
                   {previewLoading && !previewImageSrc && <Spinner size="md" style={{color:"#fff"}}/>}
                  
                   {!previewLoading && !previewImageSrc && <span className="text-white">No Preview</span>}
                   </div>
                     <p className="text-white my-2">Preview</p>
                   </div>
                   
                </Col>
                </Row>

       
            <div className="btn-submit d-flex gap-3 mt-5">
              <Button
                type="submit"
                disabled={btnLoader || !previewImageSrc || previewLoading}
                className="btnsubmit"
              >{btnLoader && <Spinner size="sm" color="light" className="mr-2 me-2" />}
               Confirm
              </Button>
            </div>
          </Form>

        </div>
      </Modal.Body>
    </Modal>
  );
}
